import store from "../../../store/store";
import constants from "../../../utils/constants";
import axios from "../../axios";
// Token Refresh
let isAlreadyFetchingAccessToken = false;
let subscribers = [];

function onAccessTokenFetched(access_token) {
	subscribers = subscribers.filter(callback => callback(access_token));
}

function addSubscriber(callback) {
	subscribers.push(callback);
}

export default {
	getProvince(payload) {
		return axios.post(constants.API.ADDRESSES.PROVINCE, payload);
	},
	getDistrict(payload) {
		return axios.post(`${constants.API.ADDRESSES.DISTRICT}`, payload);
	},
	getWard(payload) {
		return axios.post(`${constants.API.ADDRESSES.WARD}`, payload);
	}
};
